export default __webpack_public_path__ + "static/media/pin_start.59476678.svg";